import { render, staticRenderFns } from "./ScopeDialog.vue?vue&type=template&id=ef58bfdc&scoped=true"
import script from "./ScopeDialog.vue?vue&type=script&lang=js"
export * from "./ScopeDialog.vue?vue&type=script&lang=js"
import style0 from "./ScopeDialog.vue?vue&type=style&index=0&id=ef58bfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef58bfdc",
  null
  
)

export default component.exports